import React from 'react';
import { HeroBanner } from '../components/home/HeroBanner';
import { FeaturesSection } from '../components/home/FeaturesSection';
import { CategorySection } from '../components/home/CategorySection';
import { FeaturedProducts } from '../components/home/FeaturedProducts';
import { DealsSection } from '../components/home/DealsSection';
import { PromoBanners } from '../components/home/PromoBanners';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { NewsletterSection } from '../components/home/NewsletterSection';
import { BrandsSection } from '../components/home/BrandsSection';
import { featuredProducts, bestSellers, newArrivals, dealsOfTheDay } from '../data/products';
export function HomePage() {
  return <div className="min-h-screen" data-id="element-1371" data-mp="31yan515y45xg">
      {/* Hero & Category Sidebar Section */}
      <div className="bg-white pt-4 pb-8" data-id="element-1372" data-mp="2e8gb2ltgale9">
        <div className="max-w-7xl mx-auto px-4" data-id="element-1373" data-mp="29axy8kcbbm0z">
          <div className="flex flex-col lg:flex-row gap-6" data-id="element-1374" data-mp="29a520dazcex3">
            {/* Desktop Sidebar */}
            <CategorySection data-id="element-1375" data-mp="2ao3lyomyb8nx" />

            {/* Hero Banner */}
            <div className="flex-1 overflow-hidden rounded-xl" data-id="element-1376" data-mp="2eq88z4iw971l">
              <HeroBanner data-id="element-1377" data-mp="2eodn9nzstawg" />
            </div>
          </div>
        </div>
      </div>

      <FeaturesSection data-id="element-1378" data-mp="2jhyqbug90v2i" />

      <FeaturedProducts title="Featured Products" subtitle="Handpicked gadgets just for you" products={featuredProducts} viewAllLink="/products?featured=true" data-id="element-1379" data-mp="2jjjcavohz5or" />

      <DealsSection products={dealsOfTheDay} data-id="element-1380" data-mp="1rrlkhfiavueh" />

      <PromoBanners data-id="element-1381" data-mp="1vrcia368vasi" />

      <FeaturedProducts title="Best Sellers" subtitle="Most loved by our customers" products={bestSellers} viewAllLink="/products?bestseller=true" data-id="element-1382" data-mp="1vquemlh95uak" />

      <div className="bg-gray-50" data-id="element-1383" data-mp="20ss622zt3vel">
        <FeaturedProducts title="New Arrivals" subtitle="Fresh additions to our collection" products={newArrivals} viewAllLink="/products?new=true" data-id="element-1384" data-mp="25qbhyw917w3d" />
      </div>

      <TestimonialsSection data-id="element-1385" data-mp="3c7yl30h1crrn" />
      <BrandsSection data-id="element-1386" data-mp="3h4p33tcehxfp" />
      <NewsletterSection data-id="element-1387" data-mp="3h45rsvh9a7an" />
    </div>;
}